import { render } from "./add-form.vue?vue&type=template&id=07dd36cd&scoped=true"
import script from "./add-form.vue?vue&type=script&lang=js"
export * from "./add-form.vue?vue&type=script&lang=js"

import "./add-form.vue?vue&type=style&index=0&id=07dd36cd&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07dd36cd"]])

export default __exports__